export const handleMenuBlur = (e: any, closeFn: (visible: boolean) => void) => {
  // close the menu if focusing away from it and any of its children
  if (!e?.currentTarget.contains(e.relatedTarget)) {
    closeFn(false);
  }
};
